import template from './adpSideModal.html';
import controller from './adpSideModal.controller';
import './adpSideModal.less';

let adpSideModalComponent = {
  restrict: 'E',
  bindings: {
    show: '='
  },
  transclude: {
    header: '?sideModalHeader',
    content: '?sideModalContent',
    footer: '?sideModalFooter'
  },
  template,
  controller
};

export default adpSideModalComponent;



// WEBPACK FOOTER //
// ./src/app/components/adpSideModal/adpSideModal.component.js